module.exports = __webpack_public_path__ + "static/media/DsFolderWhite.7714ef9b.svg";